import { useState } from 'react';
import { useForm } from "react-hook-form";
import { EmailTypeInput } from "../../forms/email-type-input";
import { getAuth, sendPasswordResetEmail } from "@firebase/auth";
import BaseCardLayout from "../../base-card-layout/base-card-layout";
import BaseCardLayoutActions from "../../base-card-layout/base-card-layout-actions";
import ErrorIcon from '@mui/icons-material/Error';
import { useTranslation } from 'react-i18next';
import i18n from '../../../i18n';
import { createLogger } from '../../../utilities/logger';

const log = createLogger("ResetPassword");

const COMPONENT_CLASS = "p-reset-password";

export interface ResetPasswordProps {
    onReset: Function,
    onCancelReset: Function,
}

const ResetPassword: React.FunctionComponent<ResetPasswordProps> = (props) => {
    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm();
    const { onReset, onCancelReset } = props;
    const [, setSubmitting] = useState<boolean>(false);
    const [invalidEmailError, setInvalidEmailError] = useState<boolean>(false);
    const { t } = useTranslation();
    // const formRef = useRef();

    const onSubmit = async (data: any) => {
        setSubmitting(true);
        const auth = getAuth();
        const email = data.email;
        auth.languageCode = i18n.language;
        sendPasswordResetEmail(auth, email)
            .then((r) => {
                log.info("Password reset email sent", {
                    email,
                });
                reset();
                setSubmitting(false);
                onReset();
            })
            .catch((error) => {
                log.error("Failed to send password reset email", {
                    exception: error,
                    email,
                });
                setInvalidEmailError(true);
                setSubmitting(false);
            });
    }

    return (
        <BaseCardLayout>
            <div className="flex justify-center" style={{ height: "550px" }}>
                <div className={`${COMPONENT_CLASS}`}>
                    {
                        // if
                        invalidEmailError && (
                            <div className={`${COMPONENT_CLASS}__email-error`}>
                                <div style={{ display: "flex", flexDirection: "row" }}>
                                    <ErrorIcon color="error"></ErrorIcon>
                                    <h4 style={{
                                        paddingTop: "3px",
                                        marginLeft: "5px"
                                    }}>{t('login.resetPass.banner.invEmail_title')}</h4>
                                </div>
                                <p>{t('login.resetPass.banner.invEmail_text')}</p>
                            </div>
                        )
                    }
                    <div className={`${COMPONENT_CLASS}__container`}>
                        <form className={"login-form"}
                            onSubmit={handleSubmit(onSubmit)}>
                            <p className={`${COMPONENT_CLASS}__title`}>{t('login.resetPass.title')}</p>

                            <p className={`${COMPONENT_CLASS}__subtitle`}>{t('login.resetPass.resetPass_subText')}</p>
                            <div className={`${COMPONENT_CLASS}__field-container`}>
                                <EmailTypeInput
                                    id="email"
                                    label={t('general.email')}
                                    hideLabel
                                    registerHook={register}
                                    errorState={errors.email}
                                    noMatchEmail={invalidEmailError} />
                            </div>
                            <div {...register("formErrors")}>
                                {errors.formErrors &&
                                    <span className="error-style" role="alert">
                                        {`${errors.formErrors.message}`}
                                    </span>
                                }
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div style={{ marginTop: "1.8%", width: "100%" }}>
                <BaseCardLayoutActions backButton={true} submitButton={true} onSubmit={handleSubmit(onSubmit)} onBack={() => { onCancelReset() }} submitButtonText={t('buttons.btn_reset')}></BaseCardLayoutActions>
            </div>
        </BaseCardLayout>
    );
};

export default ResetPassword;
